import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import initData from 'packages/init-data';
import { logger } from 'packages';
import globalStore from 'state/configure-store';
import { SiteHeader } from 'components';
const el = document.querySelector('[data-site-header-slim]');

export default () => {
    if (el && initData) {
        const cartItemCount = el.getAttribute('data-cart-item-count');
        const cartSum = el.getAttribute('data-cart-sum');

        try {
            render(
                <Provider store={globalStore}>
                    <SiteHeader cartItems={cartItemCount} cartSum={cartSum} />
                </Provider>,
                el
            );
        } catch (e) {
            logger(e);
        }
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/containers/navigation/main-navigation.js